import { render, staticRenderFns } from "./DialogEdit.vue?vue&type=template&id=127df69a&scoped=true"
import script from "./DialogEdit.js?vue&type=script&lang=js&external"
export * from "./DialogEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127df69a",
  null
  
)

export default component.exports